import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ColunaBoard from './colunaBoard';
import { IEsteira } from '../../interfaces/IEsteira';
import { useAuth } from '../../contexts/AuthProvider';
import { useCallback, useEffect, useState } from 'react';
import { IRelatorio } from '../../interfaces/IRelatorio';
import RelatoriosService from '../../services/RelatoriosService';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import ModalCard from './modal-card';
import ModalExtratoBancario from './modal-extrato-bancario';
import { IArquivoCardEsteira } from '../../interfaces/IArquivoCardEsteira';
import ArquivoCardEsteiraService from '../../services/ArquivoCardEsteiraService';
import { subscribeToEsteira } from '../../services/CardNotificationService';

/*Tradução */
import './../../../i18n/config';
import { useTranslation } from 'react-i18next';

const Board = ({ esteira, empresaID, connection, mostrarReferencial }: { esteira: IEsteira, empresaID: number, connection: signalR.HubConnection, mostrarReferencial: boolean }) => {

    const { usuario } = useAuth();
    const history = useHistory();
    const { t } = useTranslation();
    const [carregandoFiltro, setCarregandoFiltro] = useState<boolean>(false);
    const [filtro, setFiltro] = useState<string>('');
    const [intervalo, setIntervalo] = useState<any>(null);

    const [dados, setDados] = useState<IRelatorio[]>([]);
    const [cartaoDestacar, setCartaoDestacar] = useState<any[]>([]);
    const [mensagemSistema, setMensagemSistema] = useState<any[]>([]);

    const [movimentarDe, setMovimentarDe] = useState<string>('');
    const [movimentarPara, setMovimentarPara] = useState<string>('');
    const [grupo, setGrupo] = useState<string>('');
    const [loadingMovimentando, setLoadingMovimentando] = useState<boolean>(false);
    const [conciliando, setConciliando] = useState<boolean>(false);
    const [modalExtratoBancario, setModalExtratoBancario] = useState<{ show: boolean; cartaoId: number; cartaoCodigo: string }>({
        show: false,
        cartaoId: 0,
        cartaoCodigo: ''
    });
    const [modal, setShowModal] = useState<any>({
        show: false,
        data: null,
        reprocessar: null
    });

    const showModal = useCallback((codigo, reprocessar) => {
        const acc = dados.find((item) => item.contaEmpresa === codigo);

        setShowModal({
            show: true,
            data: acc,
            updateDescription: (description: string) => {
                setDados((old: IRelatorio[]) => {
                    const value = old || [];
                    const newReference = [...value];
                    const findIndex = newReference.findIndex(f => f.contaEmpresa === acc?.contaEmpresa);
                    if (findIndex >= 0) {
                        newReference[findIndex].descricao = description;
                    }

                    return newReference;
                });

                RelatoriosService.atualizarDescricaoConta(esteira.id, acc?.contaEmpresa || "", description);
            },
            reprocessar: reprocessar ? (anexos: IArquivoCardEsteira[]) => {
                reprocessar(anexos);
                setShowModal({
                    show: false,
                    data: null,
                    reprocessar: null
                });
            } : null
        });
    }, [dados, esteira]);

    const loadData = useCallback((codigo, status) => {
        setDados((old: IRelatorio[]) => {
            if (old) {
                const copy = [...old];
                const index = old?.findIndex((item) => item.contaEmpresa === codigo);
                if (index >= 0) {
                    copy[index].status = status;
                }

                return copy;
            }

            return old;
        })
    }, []);

    const filtroTexto = useCallback((item: IRelatorio) => {
        if (filtro) {
            return `${item.contaEmpresa}-${item.descricaoEmpresa}-${item.contaReferencial}`.toLowerCase().includes(filtro.toLowerCase()) ? item : null;
        }

        return item;
    }, [filtro]);

    const aggragateData = useCallback((newData: IRelatorio[]) => {
        setDados((old) => {
            const cp = [...old];
            const codeExist = cp.map(m => m.contaEmpresa);
            const diff = newData.filter(f => !codeExist.includes(f.contaEmpresa));
            const newer = cp.concat(diff);
            return newer;
        })
    }, [dados]);

    const onSearch = useCallback(() => {

        if (!filtro) {
            Swal.fire({
                text: 'Por favor preencha o filtro.',
                timer: 10000,
                icon: 'error',
                showConfirmButton: false
            });
            return;
        }

        setCarregandoFiltro(true);
        RelatoriosService.buscarCartaoPorFiltro(esteira.id, filtro, true, (resp) => {
            setCarregandoFiltro(false);
            aggragateData(resp);
        })
    }, [filtro, esteira, aggragateData]);

    const movimentarGrupo = useCallback(async () => {
        if (!movimentarDe || !movimentarDe || !grupo) {
            Swal.fire({
                text: 'Por favor selecione o destino de sua movimentação e o grupo.',
                timer: 10000,
                icon: 'error',
                showConfirmButton: false
            });
            return;
        }

        setLoadingMovimentando(true);
        const result = await RelatoriosService.movimentarStatus(esteira.id, movimentarDe, movimentarPara, grupo, 'resultado');
        setLoadingMovimentando(false);


        if (result && result.message) {
            Swal.fire({
                text: result.message,
                timer: 10000,
                icon: 'error',
                showConfirmButton: false
            });
        }
        else {
            Swal.fire({
                text: 'Será processado um lote de até 1000 cartões, após processado os cartões serão atualizados em sua tela.',
                timer: 10000,
                icon: 'success',
                showConfirmButton: false
            });
        }


    }, [esteira, movimentarDe, movimentarPara, grupo]);

    const arrastar = useCallback((codigo, status, porcentagem, destacar = false, detalhes = null) => {
        setDados((old) => {
            if (old) {
                const copy = [...old];
                const index = old?.findIndex((item) => item.contaEmpresa === codigo);
                if (index >= 0) {
                    copy[index].status = status;
                    copy[index].destacar = destacar;
                    if (porcentagem != null && porcentagem !== undefined) {
                        copy[index].porcentagemConciliado = porcentagem;
                        (copy[index] as any).porcentagemProcessamento = porcentagem;
                    }
                    if (detalhes) {
                        (copy[index] as any).etapaProcessamento = detalhes.Etapa;
                        (copy[index] as any).totalLancamentos = detalhes.TotalLancamentos;
                        (copy[index] as any).pendentesProcessamento = detalhes.Pendentes;
                        (copy[index] as any).inicioProcessamento = detalhes.Inicio;
                        (copy[index] as any).fimProcessamento = detalhes.Fim;
                        (copy[index] as any).usuarioProcessamento = detalhes.Usuario;
                        (copy[index] as any).processando = true;
                    }
                } else {
                    RelatoriosService.buscarCartao(esteira.id, codigo, (resp) => {
                        if (resp) {
                            copy.push(resp);
                        }
                    });
                }

                return copy;
            }

            return old;
        });
    }, [esteira]);

    const changeRouteConciliation = useCallback((codigo) => {
        const finded = dados?.find(item => item.contaEmpresa === codigo);

        if (finded && (finded.isClienteFornecedor || finded.isTributo)) {

            Swal.fire({
                title: t('Qual forma de conciliação você gostaria?'),
                showDenyButton: true,
                showConfirmButton: true,
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
                confirmButtonText: t('Múltiplo'),
                denyButtonText: t(`Individual`),
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: t('Deseja processar em tela ?'),
                        showDenyButton: true,
                        showConfirmButton: true,
                        confirmButtonColor: 'green',
                        cancelButtonColor: 'red',
                        confirmButtonText: 'Sim',
                        denyButtonText: `Não`,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            history.push(`/conciliacao-grupo/${empresaID}/${esteira.id}/${codigo}`);
                        } else if (result.isDenied) {
                            Swal.fire({
                                title: 'Deseja processar por nota ou valor ?',
                                showDenyButton: true,
                                showConfirmButton: true,
                                confirmButtonColor: 'green',
                                cancelButtonColor: 'red',
                                confirmButtonText: 'Nota',
                                denyButtonText: `Valor`,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    const sucesso = await RelatoriosService.processarSmart(esteira.id, finded.id, "nota");
                                    if (sucesso) {
                                        arrastar(finded.contaEmpresa, "Em processamento", null);
                                        Swal.fire({
                                            text: 'Inserimos seu card para processamento. Assim que concluído, iremos notifica-lo para validação das possíveis conciliações.',
                                            timer: 10000,
                                            icon: 'success',
                                            showConfirmButton: false
                                        });
                                    }
                                } else if (result.isDenied) {
                                    const sucesso = await RelatoriosService.processarSmart(esteira.id, finded.id, "valor");
                                    if (sucesso) {
                                        arrastar(finded.contaEmpresa, "Em processamento", null);
                                        Swal.fire({
                                            text: 'Inserimos seu card para processamento. Assim que concluído, iremos notifica-lo para validação das possíveis conciliações.',
                                            timer: 10000,
                                            icon: 'success',
                                            showConfirmButton: false
                                        });
                                    }
                                }
                            });
                        }
                    });
                } else if (result.isDenied) {
                    history.push(`/conciliacao/${esteira.id}/${finded.id}`);
                }
            });
        }
    }, [esteira, empresaID, history, dados, arrastar]);

    const loadDataReport = useCallback((offset: number, status: string, setLoading, setHasMore) => {
        RelatoriosService.buscarCartoes(esteira.id, status, offset, true, (data) => {
            if (!data || data.length == 0) {
                setHasMore(false);
            }
            else {
                aggragateData(data);
            }

            setLoading(false);
        });
    }, [esteira, aggragateData]);

    useEffect(() => {
        if (!esteira) return;

        // Firestore realtime listener — substitui o hub SignalR legado (nunca implementado no
        // backend, ver ARCHITECTURE.md) para eventos de movimentação de cartão. O `connection`
        // (SignalR) continua sendo repassado ao ModalCard, que o usa para outro evento
        // ("FinalizouProcessamento"), independente deste.
        const unsubscribe = subscribeToEsteira(esteira.id, ({ conta, status, porcentagem, detalhes }) => {
            arrastar(conta, status, porcentagem, false, detalhes);
        });

        return () => unsubscribe();
    }, [esteira, arrastar]);

    useEffect(() => {
        if (esteira && !intervalo) {
            const i = setInterval(() => {
                ArquivoCardEsteiraService.buscarNotificacoes(esteira.id).then((resp) => setMensagemSistema(resp));
            }, 600000);

            setIntervalo(i);
        }


        return () => {
            clearInterval(intervalo);
        }
    }, [esteira, intervalo]);

    return (
        <div className='row'>
            <div className='col-md-12 mt-2'>
                <div className='row'>
                    <div className='col-md-3 form-group'>
                        <label>{t('De: ')} </label>
                        <select disabled={loadingMovimentando} className='form-control' value={movimentarDe} onChange={(e) => setMovimentarDe(e.target.value)}>
                            <option value=''>{t('Selecione uma opção')}</option>
                            <option value='Arquivado'>{t('Arquivado')}</option>
                            <option value='Pendentes'>{t('Pendentes')}</option>
                            <option value='Em processamento'>{t('Análise Automática')}</option>
                            <option value='Conciliado Parcial'>{t('Análise Parcial')}</option>
                            <option value='Em Conferencia'>{t('Em Conferência')}</option>
                        </select>
                    </div>
                    <div className='col-md-3 form-group'>
                        <label>{t('Para: ')}</label>
                        <select disabled={loadingMovimentando} className='form-control' value={movimentarPara} onChange={(e) => setMovimentarPara(e.target.value)}>
                            <option value=''>{t('Selecione uma opção')}</option>
                            <option value='Pendentes'>{t('Pendentes')}</option>
                            <option value='Em processamento'>{t('Análise Automática')}</option>
                            <option value='Conciliado Parcial'>{t('Análise Parcial')}</option>
                            <option value='Em Conferencia'>{t('Em Conferência')}</option>
                            <option value='Concluida'>{t('Concluído')}</option>
                        </select>
                    </div>
                    <div className='col-md-3 form-group'>
                        <label>{t("Grupo")}: </label>
                        <select disabled={loadingMovimentando} className='form-control' value={grupo} onChange={(e) => setGrupo(e.target.value)}>
                            <option value=''>{t("Selecione uma opção")}</option>
                            <option value='todas'>{t("Todos")}</option>
                            <option value='todas-100'>{t("Todos")} 100%</option>
                            <option value='clienteFornecedor'>{t("Cliente/Fornecedor")}</option>
                            <option value='tributo'>{t("Tributos")}</option>
                            <option value='imobilizado'>{t("Imobilizado")}</option>
                            <option value='pl'>PL</option>
                            <option value='emprestimo'>{t("Empréstimo")}</option>
                            <option value='banco'>{t("Banco e Caixa")}</option>
                            <option value='folha'>{t("Folha de pagamento")}</option>
                            <option value='estoque'>{t("Estoque")}</option>
                        </select>
                    </div>
                    <div className='col-md-3 mt-6'>
                        <button disabled={loadingMovimentando} className='btn btn-success' onClick={movimentarGrupo}>{t("Movimentar")}</button>
                    </div>
                </div>
            </div>


            <div className='col-md-12 mt-2'>
                <div className='row'>
                    <div className='col-md-6 form-group'>
                        <label>{t("Filtro")}:</label>
                        <input disabled={carregandoFiltro} type='text' placeholder={t('Digite aqui um filtro...')} value={filtro} onChange={(e) => setFiltro(e.target.value)} className='form-control' />
                    </div>
                    <div className='col-md-4'>
                        <button disabled={carregandoFiltro} className='btn btn-success mt-6' onClick={() => onSearch()}>{t("Buscar fora da tela")}</button>
                    </div>
                </div>
            </div>

            <ModalCard
                connection={connection}
                mostrarContaReferencial
                esteira={esteira.id}
                empresa={empresaID}
                dataI={esteira?.periodoInicio || new Date()}
                dataF={esteira?.periodoFim || new Date()}
                contas={dados}
                updateAll={loadData}
                mensagemSistema={mensagemSistema}
                showModal={showModal}
                toggleModal={() => {
                    setShowModal({
                        show: false,
                        data: null,
                        reprocessar: null
                    });
                }} updateDescription={modal.updateDescription} show={modal.show} acc={modal.data} reprocessar={modal.reprocessar} conciliacaoInteligente={modal.conciliacaoInteligente} processou conferencia={modal?.data?.status === 'Em Conferencia'} onRequestExtratoBancario={(item: any) => setModalExtratoBancario({ show: true, cartaoId: item.id, cartaoCodigo: item.contaEmpresa })} onConcluidoClick={() => {

                    RelatoriosService.updateStatusConta(modal.data.contaEmpresa, esteira.id, 'Concluida').then(() => {
                        loadData(modal.data.contaEmpresa, 'Concluida');
                        setShowModal({
                            show: false,
                            data: null,
                            reprocessar: null
                        });
                    });
                }} />

            <ModalExtratoBancario
                show={modalExtratoBancario.show}
                esteiraId={esteira.id}
                cartaoId={modalExtratoBancario.cartaoId}
                onHide={() => setModalExtratoBancario({ show: false, cartaoId: 0, cartaoCodigo: '' })}
                onSuccess={() => arrastar(modalExtratoBancario.cartaoCodigo, 'Em processamento', null)}
            />

            <div className='col-md-12 mt-2 scrollsize'>
                <DndProvider backend={HTML5Backend}>
                    <ColunaBoard showModal={showModal} loadingMovimentando={loadingMovimentando && (movimentarDe === 'Pendentes' || movimentarPara === 'Pendentes')} possuiFiltro={!!filtro} loadDataReport={loadDataReport} dados={dados.filter(f => f.status === 'Pendentes').filter(f => filtroTexto(f))} setDados={setDados} mostrarContaReferencial={mostrarReferencial} esteira={esteira} empresaID={empresaID} perfil={usuario?.perfil} responsavelContabil={usuario?.responsavelContabil || false} onConciliationInteligent={changeRouteConciliation} updateAll={arrastar} conciliando={conciliando} setConciliando={setConciliando} esteiraID={esteira.id} title={t("Pendentes")} status="Pendentes" />
                </DndProvider>
            </div>
        </div>
    )
}

export default Board;